import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/dashboard"),
  }
  ,
  {
    path: "/dashboard",
    name: "Dashboard",
    meta: {
      title: "Dashboard1",
      authRequired: true,
    },
    component: () => import("../views/dashboard/dashboard"),
  },

  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },


  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout", authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else {
          store.dispatch("authfack/logout");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
    component: () => import("../views/auth/logout/basic")
  },
  {
    path: "/order/create",
    name: "order_",
    meta: { title: "order", authRequired: true },
    component: () => import("../views/order/create"),
  },
  {
    path: "/order/crete",
    name: "order",
    meta: { title: "order", authRequired: true },
    component: () => import("../views/order/crete"),
  },
  {
    path: "/order/newcreate",
    name: "newcrete",
    meta: { title: "order", authRequired: true },
    component: () => import("../views/order/adddropdown"),
  },
  {
    path: "/price_checker",
    name: "pricechecker",
    meta: { title: "pricechecker", authRequired: true },
    component: () => import("../views/pricing/pricechecker"),
  },
  {
    path: "/order/titu",
    name: "createTitu",
    meta: { title: "order", authRequired: true },
    component: () => import("../views/order/titu"),
  },
  
  {
    path: "/order/list",
    name: "orderListCustomer",
    meta: { title: "Order List", authRequired: true },
    component: () => import("../views/order/list"),
  },
  {
    path: "/voucher/myorder/",
    name: "customerlistordervoucher",
    meta: { title: "Order Voucher", authRequired: true },
    component: () => import("../views/order/myordervoucher"),
  },
  {
    path: "/voucher/imei/:OrderId",
    name: "customerinsertImei",
    meta: { title: "Insert Imei", authRequired: true },
    component: () => import("../views/order/insertimei"),
  },
  
  {
    path: "/order/status/:statusId",
    name: "orderListCustomerStatus",
    meta: { title: "Order List", authRequired: true },
    component: () => import("../views/order/list"),
  },
  
  {
    path: "/order/management",
    name: "ordermanagement",
    meta: { title: "Order Listing", authRequired: true },
    component: () => import("../views/order/management"),
  },

  {
    path: "/order/pendingpayment",
    name: "pendingpayment",
    meta: { title: "Order Pending Payment", authRequired: true },
    component: () => import("../views/order/pendingpayment"),
  },

  {
    path: "/order/delivery",
    name: "pendingdeliverymethod",
    meta: { title: "Order Pending Payment", authRequired: true },
    component: () => import("../views/order/delivery"),
  },

  {
    path: "/order/complete",
    name: "ordercomplete",
    meta: { title: "Order complete", authRequired: true },
    component: () => import("../views/order/complete"),
  },

  {
    path: "/order/customerapproval",
    name: "ordercustomerapproval",
    meta: { title: "Order Pending Customer Approval", authRequired: true },
    component: () => import("../views/order/customerapprovallist"),
  },

  {
    path: "/order/pendingitem",
    name: "orderpendingitem",
    meta: { title: "Order Pending Customer Approval", authRequired: true },
    component: () => import("../views/order/pendingitem"),
  },

  {
    path: "/order/pendingqc",
    name: "pendingqclist",
    meta: { title: "Order Pending QC", authRequired: true },
    component: () => import("../views/order/pendingqclist"),
  },


  {
    path: "/order/pendingpayment/:OrderId",
    name: "pendingpaymentDetail",
    meta: { title: "Order Pending Payment Detail", authRequired: true },
    component: () => import("../views/order/pendingpaymentdetail"),
  },


  {
    path: "/order/test",
    name: "orderTest",
    meta: { title: "Order Test", authRequired: true },
    component: () => import("../views/order/test"),
  },

  {
    path: "/order/qc/:OrderId",
    name: "Customer Approvel After QC",
    meta: { title: "Order Detail", authRequired: true },
    component: () => import("../views/order/CustomerApproval"),
    props: true,
  },

  {
    path: "/order/details/:OrderId",
    name: "OrderDetail",
    meta: { title: "Order Detail", authRequired: true },
    component: () => import("../views/order/detail"),
    props: true,
  },
  {
    path: "/enquiry",
    name: "Enquiry",
    meta: { title: "Enquiry", authRequired: true },
    component: () => import("../views/enquiry/enquiry_option"),
    // props: true,
  },
  {
    path: "/enquiry/cust/:custId",
    name: "Enquiry Detail",
    meta: { title: "Enquiry Detail", authRequired: true },
    component: () => import("../views/enquiry/enquiry_option_admin"),
  },
  {
    path: "/order/cq/:OrderId",
    name: "ConditionalQuotation",
    meta: { title: "Order Detail", authRequired: true },
    component: () => import("../views/receipt/conditionQuotation"),
    props: true,
  },

  {
    path: "/po/tnc",
    name: "potnc",
    meta: { title: "PO Term and condition", authRequired: true },
    component: () => import("../views/setting/po_tnc.vue"),
    props: true,
  },

  {
    path: "/order/po/:OrderId",
    name: "purchaseorder",
    meta: { title: "Order Detail", authRequired: true },
    component: () => import("../views/receipt/po"),
    props: true,
  },

  
  {
    path: "/invoice/:OrderId",
    name: "InvoiceView",
    meta: { title: "Receipt Detail", authRequired: true },
    component: () => import("../views/receipt/view"),
    props: true,
  },
  



  {
    path: "/pricing",
    name: "pricing",
    meta: { title: "Pricing", authRequired: true },
    component: () => import("../views/pricing/create"),
  },

  {
    path: "/pricing/temporary",
    name: "pricingtemporary",
    meta: { title: "Pricing", authRequired: true },
    component: () => import("../views/pricing/temporary"),
  },


  {
    path: "/pricing/:brand",
    name: "pricingBrand",
    meta: { title: "Pricing", authRequired: true },
    component: () => import("../views/pricing/brand"),
  },

  {
    path: "/pricing/:brand/:currency",
    name: "pricingBrandCountry",
    meta: { title: "Pricing", authRequired: true },
    component: () => import("../views/pricing/brand"),
  },


  {
    path: "/user/roles",
    name: "UserRoles",
    meta: { title: "User Roles", authRequired: true },
    component: () => import("../views/user/role"),
  },


  {
    path: "/profile",
    name: "myprofile",
    meta: { title: "My Profile", authRequired: true },
    component: () => import("../views/user/profile"),
  },


  {
    path: "/report",
    name: "report",
    meta: { title: "report", authRequired: true },
    component: () => import("../views/report/report"),
  },
  
  {
    path: "/report/:search",
    name: "report_detail",
    meta: { title: "report", authRequired: true },
    component: () => import("../views/report/report"),
  },
  
  
  {
    path: "/widgets",
    name: "widgets",
    meta: { title: "Widgets", authRequired: true },
    component: () => import("../views/widgets/index"),
  },
  {
    path: "/pages/starter",
    name: "starter",
    meta: { title: "Starter", authRequired: true },
    component: () => import("../views/pages/starter"),
  },
  {
    path: '/auth/signin-basic',
    name: 'signin-basic',
    meta: {
      title: "Signin Basic", authRequired: true,
    },
    component: () => import('../views/auth/signin/basic')
  },
  {
    path: '/auth/signin-cover',
    name: 'signin-cover',
    meta: {
      title: "Signin Cover",
    },
    component: () => import('../views/auth/signin/cover')
  },
  {
    path: '/auth/signup-basic',
    name: 'signup-basic',
    meta: {
      title: "Signup Basic", authRequired: true,
    },
    component: () => import('../views/auth/signup/basic')
  },
  {
    path: '/auth/signup-cover', //here
    name: 'signup-cover',
    meta: {
      title: "Signup Microsite",
    },
    component: () => import('../views/auth/signup/cover')
  },
  {
    path: '/auth/reset-pwd-basic',
    name: 'reset-pwd-basic',
    meta: {
      title: "Reset Password", authRequired: true,
    },
    component: () => import('../views/auth/reset/basic')
  },
  {
    path: '/auth/reset-pwd-cover',
    name: 'reset-pwd-cover',
    meta: {
      title: "Reset Password", authRequired: true,
    },
    component: () => import('../views/auth/reset/cover')
  },
  {
    path: '/auth/create-pwd-basic',
    name: 'create-pwd-basic',
    meta: {
      title: "create Password",
    },
    component: () => import('../views/auth/create/basic')
  },
  {
    path: '/auth/create-pwd-cover',
    name: 'create-pwd-cover',
    meta: {
      title: "create Password", authRequired: true,
    },
    component: () => import('../views/auth/create/cover')
  },
  {
    path: '/auth/lockscreen-basic',
    name: 'lock-screen-basic',
    meta: {
      title: "Lock Screen", authRequired: true,
    },
    component: () => import('../views/auth/lockscreen/basic')
  },
  {
    path: '/auth/lockscreen-cover',
    name: 'lock-screen-cover',
    meta: {
      title: "Lock Screen", authRequired: true,
    },
    component: () => import('../views/auth/lockscreen/cover')
  },
  {
    path: '/auth/twostep-basic',
    name: 'twostep-basic',
    meta: {
      title: "Two Step Auth", authRequired: true,
    },
    component: () => import('../views/auth/twostep/basic')
  }, {
    path: '/auth/twostep-cover',
    name: 'twostep-cover',
    meta: {
      title: "Two Step Auth", authRequired: true,
    },
    component: () => import('../views/auth/twostep/cover')
  },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: true,
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404-basic',
    name: '404-basic',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404-basic')
  },
  {
    path: '/auth/404-cover',
    name: '404-cover',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404-cover')
  },
  {
    path: '/auth/ofline',
    name: 'ofline',
    meta: {
      title: "Oflone", authRequired: true,
    },
    component: () => import('../views/auth/errors/ofline')
  },
  {
    path: '/auth/logout-basic',
    name: 'logout-basic',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/basic')
  },
  {
    path: '/auth/logout-cover',
    name: 'logout-cover',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/cover')
  },
  {
    path: '/auth/success-msg-basic',
    name: 'success-msg-basic',
    meta: {
      title: "Success Message", authRequired: true,
    },
    component: () => import('../views/auth/success-msg/basic')
  },
  {
    path: '/auth/success-msg-cover',
    name: 'success-msg-cover',
    meta: {
      title: "Success Message", authRequired: true,
    },
    component: () => import('../views/auth/success-msg/cover')
  },
  {
    path: "/voucher",
    name: "voucher",
    meta: { title: "Voucher Creation", authRequired: true },
    component: () => import("../views/voucher/voucherlist"),
  },
];